<template>
    <PopupRouterViewDetail label="Work Order Execution Hold Time Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Hold Time" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="workOrderExecutions" optionsLabel="shift" optionsKey="id" label-cols-lg="12" label="Work Order Execution" id="fieldset-work-order-execution" size="sm" :model.sync="model.workOrderExecutionId" :isRequired="true" :state="validateState('workOrderExecutionId')" :errorMessage="getErrorMessage(errorMessage.workOrderExecutionId, 'workOrderExecutionId')"   :selected="model.workOrderExecution != null ? model.workOrderExecution.shift : ''" @input="getWorkOrderExecutions" @change="updateData" :isEditable="true" :isUpdatable="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderExecution" />
						<app-input-datetimepicker id="fieldset-start-time" label-cols-lg="12"  label="Start Time" size="sm" :model.sync="model.startTime"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="true" :isUpdatable="true"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textarea id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="model.remark"  @change="updateData" :isEditable="true" :isUpdatable="true"/>
						<app-input-datetimepicker id="fieldset-end-time" label-cols-lg="12"  label="End Time" size="sm" :model.sync="model.endTime"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="true" :isUpdatable="true"/>
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import toast from '@/mixins/toastMixin';
import { required, minLength } from "vuelidate/lib/validators";
import WorkOrderExecutionHoldTime from '@/models/WorkOrderExecutionHoldTime/WorkOrderExecutionHoldTime';
import WorkOrderExecutionHoldTimeList from '@/models/WorkOrderExecutionHoldTime/WorkOrderExecutionHoldTimeList';
import WorkOrderExecutionHoldTimeFilter from '@/filters/WorkOrderExecutionHoldTime/WorkOrderExecutionHoldTimeFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';
import WorkOrderExecutionFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextarea,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin, toast],
	validations: {
		model: {
			workOrderExecutionId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				workOrderExecutionId: { required : "Work Order Execution is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {
				workOrderExecutionId: null,

			},
			filterWorkOrderExecutionHoldTime : null,
			currentWorkOrderExecutionHoldTimePage : 1,
			workOrderExecutionHoldTimePageSize: 10,
			sortByWorkOrderExecutionHoldTime: '',
			sortDescWorkOrderExecutionHoldTime: '',
			workOrderExecutions: [],
			workOrderExecutions: [],
			isWorkOrderExecutionComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			usePopup: false,
			isWorkOrderExecutionComboLoading: false,
		}
	},
	methods : {
		doHidden(row, modalType){
			row.toggleDetails()
			this.resetModal(modalType)
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getWorkOrderExecutionHoldTime : async function(id) {
			this.isBusy = true;
			WorkOrderExecutionHoldTime.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadWorkOrderExecutionHoldTime = true;
			this.filterWorkOrderExecutionHoldTime.id = this.modelId;
			WorkOrderExecutionHoldTime.downloadDataDetail(this, this.filterWorkOrderExecutionHoldTime).then(result => {
				this.isDownloadWorkOrderExecutionHoldTime = false;
			}).catch(error => { this.isDownloadWorkOrderExecutionHoldTime = false; })
		},
		getWorkOrderExecutionHoldTimes : async function(input) {
			let filter = new WorkOrderExecutionHoldTimeFilter();
			if (input != undefined) {
				filter.WorkOrderExecution = input;
			}
			this.isWorkOrderExecutionHoldTimeComboLoading = true;
			WorkOrderExecutionHoldTime.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutionHoldTimes = result.data
				}
				this.isWorkOrderExecutionHoldTimeComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderExecutions : async function(input) {
			let filter = new WorkOrderExecutionFilter();
			if (input != undefined) {
				filter.shift = input;
			}
			WorkOrderExecution.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutions = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderExecution(item) {
			if(item == undefined || item == null) {
				this.model.workOrderExecutionId = null;
				this.model.workOrderExecution = null;
			} else {
				this.model.workOrderExecutionId = item.id;
				this.model.workOrderExecution = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.workOrderExecutionHoldTimeInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				this.toast({ message: 'There are still mandatory fields that need to be filled in. Please double check your input.', title: 'Error', variant: 'danger', autoHideDelay:1500});
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						WorkOrderExecutionHoldTime.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'workorderexecutionholdtimeindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						WorkOrderExecutionHoldTime.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'workorderexecutionholdtimeindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderExecutionHoldTime.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getWorkOrderExecutionHoldTime(id);
					});
				}
			});
		},
		onHidden() {
			this.getWorkOrderExecutionHoldTimes();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}

			if(this.windowWidth <= 576) {
				this.usePopup = true
			} else {
				this.usePopup = false
			}
		},
	},
	beforeMount() {
		this.filterWorkOrderExecutionHoldTime = new WorkOrderExecutionHoldTimeFilter();
		//this.getWorkOrderExecutions();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getWorkOrderExecutionHoldTime(id);
			} else {
				this.modelId = id;
				this.getWorkOrderExecutionHoldTime(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
